import { Empty } from '@/components/lemmala-design-system/empty/empty'

type ErrorEmptyStateProps = {
  title: string
}

export const ErrorEmptyState = ({ title }: ErrorEmptyStateProps) => {
  return <Empty icon='not-found' title={title} />
}
